export const TIME_SLOT_HEIGHT = 13
export const STEP_TIME_MINUTES = 30
export const START_HOUR = 8
export const END_HOUR = 23
export const TOTAL_MINUTES = (END_HOUR - START_HOUR) * 60
export const TOTAL_HEIGHT =
	(TOTAL_MINUTES / STEP_TIME_MINUTES) * TIME_SLOT_HEIGHT

export const calculateTimeFromY = (y: number) => {
	const minutes = calculateMinutes(y)
	return formatTime(minutes)
}

export const snapToGrid = (value: number): number =>
	Math.round(value / TIME_SLOT_HEIGHT) * TIME_SLOT_HEIGHT

export const calculateY = (minutes: number): number =>
	Math.max(
		0,
		Math.min((minutes / STEP_TIME_MINUTES) * TIME_SLOT_HEIGHT, TOTAL_HEIGHT),
	)

export const calculateMinutes = (y: number): number =>
	Math.floor(y / TIME_SLOT_HEIGHT) * STEP_TIME_MINUTES

export const parseTime = (timeString: string) => {
	const [hours, minutes] = timeString.split(':').map(Number)
	return (hours - START_HOUR) * 60 + minutes
}

export const formatTime = (minutes: number) => {
	const hours = START_HOUR + Math.floor(minutes / 60)
	const mins = minutes % 60
	return `${hours.toString().padStart(2, '0')}:${mins
		.toString()
		.padStart(2, '0')}`
}

export interface TimeslotBounds {
	startY: number
	height: number
}
